/**
 *
 * Asynchronously loads the component for BranchSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const BranchSetup = lazyLoad(
  () => import('./index'),
  module => module.BranchSetup,
);
